import { useSelector } from 'react-redux';
import { Box, SimpleGrid, VStack } from '@chakra-ui/react';
import { Button, Heading, Image, Text } from '@/components/v4';
import CardDetails from 'pages/dashboards/v5/components/CardDetails';
import { SBC, SRT } from 'pages/dashboards/v5/constants';

/**
 * Which service a new trunk is built against.
 *
 * Shown only when a company runs both SBCaaS variants — with one service there
 * is nothing to choose, so the caller skips straight to the trunk itself. The
 * two are presented side by side rather than merged into one trunk type list so
 * the newer service is visible rather than buried among the classic types.
 */
const ServiceOption = ({ serviceType, darkMode, onSelect }) => {
    const { serviceName, icon, addDescription } = CardDetails(serviceType);

    return (
        <Box
            as="button"
            type="button"
            textAlign="left"
            borderRadius={15}
            padding="24px"
            height="100%"
            bg={darkMode ? 'dark.tcap' : 'white'}
            border="1px solid"
            borderColor={darkMode ? 'dark.tcap-borderGray' : 'gray.200'}
            _hover={{ borderColor: 'brand.500' }}
            _focusVisible={{ boxShadow: 'outline' }}
            onClick={() => onSelect(serviceType)}>
            <VStack align="flex-start" spacing={3} height="100%">
                <Image src={icon} sx={{ maxWidth: '50px' }} />
                <Heading as="h4" size="sm">
                    {serviceName}
                </Heading>
                <Text fontSize="sm" marginBottom={0}>
                    {addDescription}
                </Text>
            </VStack>
        </Box>
    );
};

const TrunkServiceChoice = ({ onSelect, onBack }) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <>
            <Heading
                as="h3"
                fontSize="lg"
                fontWeight={600}
                mb={4}
                color={darkMode ? 'white' : '#262626'}>
                Which service is this trunk for?
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} maxWidth={895}>
                {[SBC, SRT].map((serviceType) => (
                    <ServiceOption
                        key={serviceType}
                        serviceType={serviceType}
                        darkMode={darkMode}
                        onSelect={onSelect}
                    />
                ))}
            </SimpleGrid>

            <Box sx={{ marginTop: '25px', display: 'flex', gap: 2 }}>
                <Button
                    variant="outline"
                    sx={{ background: 'white', minWidth: '120px' }}
                    onClick={onBack}>
                    Back
                </Button>
            </Box>
        </>
    );
};

export default TrunkServiceChoice;
